import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {TldManagerUserService} from "../../../user/services/tld-manager-user.service";
import {whitelistCharacterValidator} from "common-domain";

@Component({
  selector: 'app-reset-password-init',
  templateUrl: './reset-password-init.component.html',
  styleUrls: ['./reset-password-init.component.scss']
})
export class ResetPasswordInitComponent implements OnInit {
  emailSent: boolean;
  resetPasswordForm: FormGroup;
  errorMessages: any;

  constructor(private titleService: Title, private formBuilder: FormBuilder, private userService: TldManagerUserService) {
  }

  ngOnInit() {
    this.createForm();
    this.titleService.setTitle('Reset Password');
  }

  onSubmit() {
    const userName = this.resetPasswordForm.getRawValue().userName;
    this.userService.initResetPassword(userName).subscribe(data => {
    }, error => {
      this.errorMessages = error;
    }, () => {
      this.emailSent = true;
    });
  }

  private createForm() {
    this.resetPasswordForm = this.formBuilder.group({
      userName: new FormControl('', [Validators.required, whitelistCharacterValidator, this.validateUsername()]),
    });
  }

  validateUsername(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const hasAtSymbol = value.indexOf('@') !== -1;
      return hasAtSymbol ? {invalidFormat: true} : null;
    }
  }
}
